import { render, staticRenderFns } from "./NoMobileNoticeDialog.vue?vue&type=template&id=566cc693&scoped=true"
import script from "./NoMobileNoticeDialog.vue?vue&type=script&lang=js"
export * from "./NoMobileNoticeDialog.vue?vue&type=script&lang=js"
import style0 from "./NoMobileNoticeDialog.vue?vue&type=style&index=0&id=566cc693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566cc693",
  null
  
)

export default component.exports